var TECL_ProductAlerts = {
    Initialise: function() {
        $( document ).ready( function() {
            $( document ).on( "click", "#openSubscribeToProductAlertsModal", function( e ) {
                TECL_ProductAlerts.OpenSubscribeModal( e );
            } );

            $( document ).on( "click", ".submit-product-alert-subscription", function( e ) {
                var productId = $( "#productAlertSubscriptionProductId" ).val();
                var emailAddress = $( "#productAlertSubscriptionEmail" ).val();
                var alertTypeId = $( "#productAlertSubscriptionAlertType" ).val();

                TECL_ProductAlerts.SubscribeToAlertsForProduct( productId, emailAddress, alertTypeId );
            } );
        } );
    },
    OpenSubscribeModal: function( e ) {
        $( "#subscribeToProductAlertsModal" ).modal( "show" );   
    },
    SubscribeToAlertsForProduct: function( productId, emailAddress, alertTypeId ) {
        function error( data ) {
            alert( "There was an error subscribing to alerts for this product. Please try again later." );
            console.log( data );
        }

        if ( TECL_Master.IsEmailAddress( emailAddress ) ) {
            $( "#productAlertSubscriptionEmail" ).siblings( ".field-validation-error" ).hide();

            $.ajax( {
                url: "/umbraco/Surface/ProductAlertSurface/SubscribeToAlertsForProduct",
                type: "POST",
                data: {
                    productId: productId,
                    emailAddress: emailAddress,
                    alertTypeId: alertTypeId
                },
                success: function( data ) {
                    if ( !data.success ) {
                        error( data );
                    } else {
                        $( "#subscribeToProductAlertsModal" ).modal( "hide" );
                        $( "#productAlertSuccessModal" ).modal( "show" );
                    }
                },
                error: function( data ) {
                    error( data );
                }
            } );
        } else {
            $( "#productAlertSubscriptionEmail" ).siblings( ".field-validation-error" ).show();
        }

        
    }
}